import { ReactNode, useEffect, useState, useContext } from 'react';
import Head from 'next/head';
import ErrorPage from 'next/error';

import ListingDetail from '@app/Listing/Detail/Detail';
import AppHeaderLayout from '@app/Layouts/AppHeaderLayout';
import { fetchAPI } from '@root/lib/fetchAPI';
import { LISTING_BY_UUID } from '@queries/listings';
import { AppContext } from '@context/AppContext';

interface Props {
  listingItem: Dict;
  selectedDays: Date[];
}

export default function AppListingDetail(props: Props): ReactNode {
  const appContext = useContext(AppContext);
  const [ listing, setListing ] = useState(null);
  const [ loaded, setLoaded ] = useState(false);

  useEffect(() => {
    setListing(props.listingItem || null);
    appContext.setSelectedListing(props.listingItem || null);
    setLoaded(true);
  }, [ props.listingItem ]);

  if (!listing && loaded) {
    return <ErrorPage statusCode={ 404 } />;
  }

  return (
    <>
      <Head>
        <title>YourDesq | { listing?.title || 'Loading...' }</title>
        <meta property="og:image" content={ props.listingItem?.listings_media[0].url } />
      </Head>
      { listing &&
        <ListingDetail
          selectedDays={ props.selectedDays }
          listing={ listing }
        />
      }
    </>
  );
}

AppListingDetail.Layout = AppHeaderLayout;

export async function getServerSideProps(context): Promise<Dict> {
  const { uuid } = context.query;

  const listingData = await fetchAPI(LISTING_BY_UUID, {
    variables: {
      uuid,
    },
  });

  let listingItem = listingData.data.listings[0];

  // Check which workspace is the cheapest
  let cheapest_price;

  listingItem.listings_workspaces.forEach(workspace => {
    if (!cheapest_price || workspace.price < cheapest_price) {
      cheapest_price = workspace.price;
    }
  });

  listingItem = {
    cheapest_price,
    ...listingItem,
  };

  return {
    props: {
      listingItem,
    },
  };
}
